import { render, staticRenderFns } from "./PermissionRecordChilds.vue?vue&type=template&id=07368dfc&scoped=true"
import script from "./PermissionRecordChilds.vue?vue&type=script&lang=js"
export * from "./PermissionRecordChilds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07368dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07368dfc')) {
      api.createRecord('07368dfc', component.options)
    } else {
      api.reload('07368dfc', component.options)
    }
    module.hot.accept("./PermissionRecordChilds.vue?vue&type=template&id=07368dfc&scoped=true", function () {
      api.rerender('07368dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permissionrecord/PermissionRecordChilds.vue"
export default component.exports